import React from "react";
import AppMobileInfoCard from "../AppMobileInfoCard";
import { Alert, Stack } from "@mui/material";
import MobileAppActionButtons from "../MobileAppActionButtons";

const ActiveIconContent = ({
  firstLogin,
  lastAppOpened,
  appVersion,
  osVersion,
  patientName,
  lastReadingTime,
  resendCredentialsHandler,
  openChangePasswordModalHandler,
}) => {
  return (
    <Stack gap="16px">
      <MobileAppActionButtons
        resendCredentialsHandler={resendCredentialsHandler}
        openChangePasswordModalHandler={openChangePasswordModalHandler}
      />
      <Alert severity="success">
        {patientName} is enrolled and actively using the mobile app.
      </Alert>

      <AppMobileInfoCard
        firstLogin={firstLogin}
        lastAppOpened={lastAppOpened}
        appVersion={appVersion}
        osVersion={osVersion}
        lastReadingTime={lastReadingTime}
      />
    </Stack>
  );
};

export default ActiveIconContent;
